<template>
  <div>
    <component
      :is="iconComponent"
      :class="[twMerge('aspect-square', $attrs.class as string)]"
    />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { twMerge } from 'tailwind-merge'

const props = defineProps<{
  name: string
}>()

const iconComponent = defineAsyncComponent(
  async () => import(`~/assets/icons/${props.name}.svg`),
)
</script>
